module.exports = __webpack_public_path__ + "static/media/PytorchAdapt_200.95a4fe73.jpg";